export type Theme = "light" | "dark" | "system";

const STORAGE_KEY = "praesto.ui.theme";

export function getTheme(): Theme {
  if (typeof localStorage === "undefined") return "system";
  return (localStorage.getItem(STORAGE_KEY) as Theme | null) ?? "system";
}

export function setTheme(t: Theme): void {
  localStorage.setItem(STORAGE_KEY, t);
  applyTheme(t);
  window.dispatchEvent(new Event("praesto:theme-change"));
}

export function applyTheme(t: Theme): void {
  const resolved =
    t === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      : t;
  document.documentElement.dataset["theme"] = resolved;
}

export function listenSystemTheme(callback: () => void): () => void {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const handler = () => callback();
  mq.addEventListener("change", handler);
  return () => mq.removeEventListener("change", handler);
}
